import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

const mobileNavStore = {
  namespaced : true ,
  state : {
    active : false
  } ,
  mutations : {
    SET__ACTIVE (state , active) {
      return state.active = active;
    }
  }
}

const mainStore = {
  namespaced : true ,
  state : {
    pages : null ,
  },
  mutations : {
    SET__PAGES (state , mains) {
      return state.pages = mains.map( n => {
        return ({
          html : `<div class="slideCommentWrap">
                  <h3>${n.summary.trim()}</h3>
                  <p>${n.explanation.replace(/\\n/ , '</br>').trim()}</p></div>` ,
          style: {
            background: `url(https://d77k7si2heyyr.cloudfront.net/upload_files/main/${n.savedFileName})`
          }
        })
      });
      //return state.pages = mains;
    }
  },
  actions : {
    API__GET__MAINS ( {commit} , payload ) {
      return new Promise( (resolve , reject) => {
        axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/main`)
          .then( ({ data }) => {
            const {mains , success} = data;
            if(success === 1){
              commit('SET__PAGES' ,mains);
              resolve(true);
            }
            else{
              reject(false);
            }
          })
          .catch( err => {
            reject(false);
          })
      })

    },
  },
  getters : {

  },
}


const issueSliderBulletStore = {
  namespaced: true,
  state: {
    currentPage: 1,
  },
  mutations: {
    slideChange: function (state, payload) {
      const {currentPage} = payload;
      return state.currentPage = currentPage;
    }
  },
  actions: {
    slideChange: function (context, payload) {
      return context.commit('slideChange', payload);
    }
  },
  getters: {
    getCurrentPage: function (state) {
      return state.currentPage;
    }
  },
};

const historyStore = {
  namespaced: true,
  state: {
    histories: [],
  },
  mutations: {
    getHistories: function (state, {histories}) {
      return state.histories = histories;
    }
  },
  actions: {
    getHistories: function (context, payload) {
      return axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/sunny/histories`)
        .then(({data}) => {
          context.commit('getHistories', data)
        })
    }
  },
  getters: {
    getHistories: function (state) {
      return state.histories;
    }
  }
}

const issueStore = {
  namespaced: true,
  state: {
    issues: [],
    /*pages : [],*/
  },
  mutations: {
    getIssues: function (state, {issues}) {
      return state.issues = issues;
    },
  },
  actions: {
    getIssues: function (context, payload) {

      return axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/sunny/issues`)
        .then(({data}) => {
          context.commit('getIssues', data)
        })
    }
  },
  getters: {
    getIssues: function (state) {
      return state.issues;
    },
  }
}

const informationStore = {
  namespaced: true,
  state: {
    information: {},
  },
  mutations: {
    getInformation: function (state, {info}) {

      return state.information = info;
    }
  },
  actions: {
    getInformation: function (context, payload) {
      return axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/sunny/info`)
        .then(({data}) => {
          context.commit('getInformation', data)
        })
    }
  },
  getters: {
    getInformationAbout: function (state) {
      return state.information.about;
    },
    getInformationLocation: (state) => {
      return state.information.location;
    }
  },
};

const categoryStore = {
  namespaced: true,
  state: {
    categories: [],
    activeCategory: [],
    isAllActive: null,
  },
  mutations: {
    setIsAllActive: function (state, {actually}) {
      //console.log(actually);
      return state.isAllActive = actually;
    },
    getCategories: function (state, {categories}) {
      return state.categories = categories;
    },
    setActiveCategory: function (state, {activeCategory, init}) {
      const itemByAll = state.categories.find(n => n.name === 'ALL');
      const itemByAllIndex = state.categories.findIndex(n => n.name === 'ALL');

      if (state.activeCategory.indexOf(activeCategory) === -1) { //존재하지않을때


        if (itemByAll.num === activeCategory) {
          return state.activeCategory = [itemByAll.num];
        }
        else {
          if (state.activeCategory.length === 5) {
            state.isAllActive = true;
            return state.activeCategory = [itemByAll.num];
          }

          return state.activeCategory = [...state.activeCategory, activeCategory];
        }

      }
      else {
        if (init === undefined || !init) {
          const idx = state.activeCategory.indexOf(activeCategory);
          return state.activeCategory.splice(idx, 1);
        }
        return null;
      }
    },
    setRemovedByAllItem: function (state) {
      const allItemIndex = state.categories.findIndex(n => n.name === 'ALL');
      //console.log(state.activeCategory.find(n => n === allItemIndex));
      return state.activeCategory.splice(allItemIndex, 1);
    },

  },
  actions: {
    getCategories: function ({commit}, payload) {
      return axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/categories`)
        .then(({data}) => {
          commit('getCategories', data);
          const {categories} = data;
          const itemByAll = categories.find(n => n.name === 'ALL');

          commit('setActiveCategory', {
            activeCategory: itemByAll !== undefined ? itemByAll.num : undefined,
            init: true,
          })

          commit('setIsAllActive', {
            actually: true
          })
        })
    }
  },
  getters: {
    getCategories: function (state) {
      return state.categories;
    },
    getCategoryByAll: function (state) {
      return state.categories.find(n => n.name === 'ALL') !== undefined ? state.categories.find(n => n.name === 'ALL').num : undefined
    },
    getActiveCategory: function (state) {
      return state.activeCategory;
    },
    getIsAllActive: function (state) {
      return state.isAllActive;
    },
  }

}

const portfolioStore = {
  namespaced: true,
  state: {
    portfolios: [],
    portfoliosFilter: [],
    VIEW__PORTFOLIO: [],
    pagination: {
      perPage: 6,
      currentPage: null,
      startPage: null,
      endPage: null,
    },


  },
  mutations: {
    getPortfolios(state, {portfolios}) {
      return state.portfolios = portfolios;
    },
    setPortfolioFilter(state, {portfolios}) {
      return state.portfoliosFilter = portfolios;
    },
    setPage(state, pagination) {
      return state.pagination = Object.assign(state.pagination, pagination);
    },
    SET__VIEW__PORTFOLIO(state, {portfolios}) {
      return state.VIEW__PORTFOLIO = portfolios;
    }

  },
  actions: {
    getPortfolios({commit}, payload) {
      return axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/portfolios/list`)
        .then(({data}) => {
          //console.log('')
          commit('getPortfolios', data);
        });

    }
  },
  getters: {
    getPortfolios(state) {
      return state.portfolios;
    },
    getPagination({pagination}) {
      return pagination;
    },
    getPortfoliosByFilter({portfoliosFilter}) {
      return portfoliosFilter;
    },
    GET__CURRENT__PAGE({pagination}) {
      return pagination.currentPage;
    },
    GET__VIEW__PORTFOLIO({VIEW__PORTFOLIO}) {
      return VIEW__PORTFOLIO;
    },
  },

}

const contactUsStore = {
  namespaced: true,
  state: {
    conformations: null,
    specificityList:
      [
        '새 프로젝트',
        '기존 프로젝트에서 변경',
        '운영 및 유지보수',
        '기타'
      ]
    ,
    selectedConformations: [],
    selectedSpecificity: null,
    attachments: [],
    information: {
      name: '',
      businessConditions: '',
      position: '',
      phoneNumber: '',
      email: '',
    },
    content: '',
  },
  mutations: {
    SET__CONFORMATIONS(state, categories) {
      return state.conformations = categories
    },
    SET__SELECTED__CONFORMATIONS(state, num) {
      const findIndex = state.selectedConformations.findIndex(n => n === num);
      if (findIndex === -1)
        return state.selectedConformations = [...state.selectedConformations, num];
      else
        return state.selectedConformations.splice(findIndex, 1)
    },
    SET__SELECTED__SPECIFICITY(state, value) {
      return state.selectedSpecificity = value;
    },
    SET__ATTACHMENT(state, file) {
      if (state.attachments.length < 10 && state.attachments.find(n => n.name === file.name) === undefined)
        return state.attachments = [...state.attachments, file];
      else
        return null;
    },
    REMOVE__ATTACHEMENT(state , i) {
      return state.attachments.splice(i , 1);
    },
    SET__CONTENT(state, content) {
      if (state.content !== content)
        return state.content = content;
      else
        return null;
    },
    SET__INFORMATION(state, {key, value}) {
      const obj = {};
      obj[key] = value;
      //state.information[key] === value
      return state.information = Object.assign(state.information, obj);
    },
    RESET__STATE(state , payload) {
      Object.keys(state).forEach(key => {
        if(key !== 'specificityList' && key !== 'conformations'){
          if(key === 'selectedConformations' || key === 'attachments'){
            state[key] = [];
          }
          else if(key === 'information'){
            state[key] = {
              name: '',
              businessConditions: '',
              position: '',
              phoneNumber: '',
              email: '',
            }
          }
          else{
            state[key] = null;
          }
        }
      });
      state.attachments = [];
      //return;
    },

  },
  actions: {
    API__GET__CATEGORIES({commit}, payload) {
      return axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/categories`)
        .then(({data}) => {
          const {categories} = data;
          commit('SET__CONFORMATIONS', categories.filter(n => n.name !== 'ALL'));
        })
    },
    API__POST__SLACK__MESSAGE({commit} , payload) {
      return new Promise( (resolve ,reject) => {
        const {
          name,
          position,
          specificity,
          conformation,
        } = payload;

        const message = [{text : `접수된 곳 : ${process.env.APP_NAME} \n성함 : ${name} \n직위 : ${position}\n프로젝트 형태 : [${conformation}]\n프로젝트 성격 : ${specificity}`}];


        const params = new URLSearchParams();
        params.append('token' , 'xoxp-242492433714-338739747138-338193215729-1c3bc17d894a91d841bcc6264f690583');
        params.append('channel' , 'general');
        params.append('text' , `새로운 프로젝트 의뢰가 들어왔습니다.`);
        params.append('attachments' , JSON.stringify(message));
        params.append('as_user' , true);


        return axios.post(`https://slack.com/api/chat.postMessage` ,
          params
        ).then( ({data}) => {
          if(data != null && data.ok){
            resolve(true);
          }else{
            reject(false);
          }
        }).catch(err => {
          reject(false);
        })


      });


    },
    API__POST__CLIENT__REQUEST({commit}, payload ) {

      return new Promise((resolve, reject) => {
        const {
          name,
            businessConditions,
            position,
            phoneNumber,
            email,
            content,
            specificity,
            conformation,
            uploadFiles
        } = payload;

        let formData = new FormData();
        for (let i = 0; i < uploadFiles.length; i++) {
          formData.append('uploadFile', uploadFiles[i]);
        }

        const requestKeys = Object.keys(payload);

        for (let i = 0 ; i < requestKeys.length; i++) {
          formData.append(requestKeys[i] , payload[requestKeys[i]]);
        }

        //console.log(formData);

        axios.post(`${process.env.API_LOCATION}${process.env.API_VERSION}/mail/send`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(({data}) => {

            const {success} = data;
            if (success) {
              commit('RESET__STATE');
              resolve(true);
            }
            else
              reject(false);
          })
          .catch( err => {
            reject(false);
          })
      })
    },
  },
  getters: {

  }
}

const noticeStore = {
  namespaced: true,
  state: {
    notices: [],
  },
  mutations: {
    getNotices(state, {notices}) {
      return state.notices = notices;
    },   

  },
  actions: {    
    API_GET_NOTICES({commit}, payload) {
      return axios.get(`${process.env.API_LOCATION}${process.env.API_VERSION}/notices/list?use=1`)
        .then(({status, data}) => {
          if(status === 200 && data && data.success === 1) {
            commit('getNotices', data);
          }
        });

    }
  },
  getters: {
    getNotices(state) {
      return state.notices;
    },    
  },

}


export const store = new Vuex.Store({
  modules: {
    mainStore : mainStore,
    issueSliderBulletStore: issueSliderBulletStore,
    informationStore: informationStore,
    historyStore: historyStore,
    issueStore: issueStore,
    categoryStore: categoryStore,
    portfolioStore: portfolioStore,
    contactUsStore: contactUsStore,
    mobileNavStore: mobileNavStore,
    noticeStore,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js